import React, { Component } from 'react';
import { connect } from 'react-redux';
import { DISPATCH_ID, SERVICE_RESPONSE, BUSINESSLICENCE, licence, DO_THE_RACE, F1_GRILL, twoStepsAuthentication } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';
import '../../css/login.css';
import packageJson from '../../../package.json';
import { BranchPermissions, CounterPermissions } from '../../components/NewOrder';
import { development } from "../../libs/utils/Const";
import TwoStepsVerificationModal from "../../components/TwoStepsVerificationModal";
import $ from "jquery";
import socketService from '../../libs/sockets/SocketService';
import { WarningModal } from '../../components';
global.appVersion = packageJson.version;
const currentVersion = global.appVersion;
const CryptoJS = require("crypto-js");
let apiClient = ApiClient.getInstance();

class LoginView extends Component {
    constructor(props) {
        let localIP = JSON.parse(localStorage.getItem(config.localStorageNamed + 'ConfigURL'));
        super(props);
        this.state = {
            key: '',
            LoginResponse: null,
            showWarningModal: false,
            database: "CONECTANDO...",
            configURL: localIP ? "local" : "public",
        }
    }


    async componentDidMount() {
        await this.getDataBase();

        let token = localStorage.getItem(config.localStorageNamed + 'Token');
        if (token) {
            this.props.history.push('/');
            return;
        }
       this.validateTokenExpired(); // Validar si el token expiro y fue devuelto al login
    }

    validateTokenExpired = async () => {
        const tokenExpired = localStorage.getItem(config.localStorageNamed + 'tokenExpired'); 
        if (tokenExpired === '1') {
            await this.setState({ showWarningModal: true });
            $('#warningModal').modal('show');
            localStorage.removeItem(config.localStorageNamed + 'tokenExpired')
        }
    }

    getDataBase = async () => {
        const apiResponse = await apiClient.getDBName();
        if (apiResponse?.status === 1) {
            this.setState({ database: apiResponse.data });
        }
    }

    registerSocket = async (loginResponse) => {
        const { U_FMB_Sucursal, Sucursal, USERID, USER_CODE, ReferredUser } = loginResponse.data.user;
        const data = {
            pkSucursal: U_FMB_Sucursal,
            sucursal: Sucursal,
            userID: USERID,
            userCode: USER_CODE,
            ReferredUser,
        };

        await socketService.emit('login', (data));
    };

    submit = async () => {
        const { loginReducer, enableSpinner, notificationReducer: { showAlert } } = this.props;
        let today = new Date();

        if (today > licence) {
            showAlert({ type: 'info', message: 'LA LICENCIA DE ESTE PRODUCTO A EXPIRADO, FAVOR DE CONTACTAR A SUS ADMINISTRADORES.' });
            return;
        }

        const user = {
            email: loginReducer.email,
            password: loginReducer.password,
        };

        enableSpinner(true);
        const loginResponse = await apiClient.login(user);
        enableSpinner(false);
        if (loginResponse.status === SERVICE_RESPONSE.ERROR) {
            showAlert({ type: 'error', message: loginResponse.message });
            return;
        }

        if (twoStepsAuthentication) {
            const data = {
                email: loginReducer.email,
                action: 1,
            }

            enableSpinner(true);
            const responseApi = await apiClient.validateTwoSteps(data);
            enableSpinner(false);

            if (responseApi.status !== 1) {
                showAlert({ type: 'error', message: responseApi.message });
                return;
            }


            showAlert({ type: 'info', message: responseApi.message });
            this.ShowDynamicModal('TwoStepsModal-TwoSteps');
            await this.setState({
                LoginResponse: loginResponse
            })
            // this.SaveDataForSuccessLogin(loginResponse)
        } else {
            await this.registerSocket(loginResponse);
            this.SaveDataForSuccessLogin(loginResponse)
        }

    };

    SaveDataForSuccessLogin = async (loginResponse) => {
        const { configReducer: { modules }, setUser } = this.props
        let userResponse = loginResponse.data.user;
        userResponse.CounterPermission = await this.FillCounterPermissions(userResponse.CounterPermission);
        userResponse.BranchPermission = await this.FillBranchPermissions(userResponse.BranchPermission);
        let dash = userResponse ? userResponse.U_FMB_Modulos : null;
        let encryptedMod = CryptoJS.AES.encrypt(JSON.stringify(modules), 'exchange').toString();

        if (dash) {
            dash = JSON.parse(dash);

            for (const key in dash) {
                if (Object.hasOwnProperty.call(dash, key)) {
                    const element = dash[key];
                    if (element.grp === 1 && element.active) {
                        dash['mktSales'].active = true;
                    } else if (element.grp === 2 && element.active) {
                        dash['mktPurchase'].active = true;
                    } else if (element.grp === 3 && element.active) {
                        dash['masterData'].active = true;
                    } else if (element.grp === 4 && element.active) {
                        dash['banking'].active = true;
                    } else if (element.grp === 5 && element.active) {
                        dash['inventoryData'].active = true;
                    } else if (element.grp === 6 && element.active) {
                        dash['inzi'].active = true;
                    } else if (element.grp === 7 && element.active) {
                        dash['actions'].active = true;
                    } else if (element.grp === 8 && element.active) {
                        dash['counter'].active = true;
                    } else if (element.grp === 9 && element.active) {
                        dash['consignmentNoteManagement'].active = true;
                    } else if (element.grp === 10 && element.active) {
                        dash['mVentas'].active = true;
                    } else if (element.grp === 11 && element.active) {
                        dash['draftsHead'].active = true;
                    } else if (element.grp === 12 && element.active) {
                        dash['support'].active = true;
                    }
                }
            }

            for (const key in modules) {
                if (Object.hasOwnProperty.call(modules, key)) {
                    const module = modules[key];
                    if (!dash.hasOwnProperty(key)) {
                        module.active = false;
                        dash[key] = module;
                    }
                }
            }
            encryptedMod = CryptoJS.AES.encrypt(JSON.stringify(dash), 'exchange').toString()//708

        }

        let U_FMB_ConfigModules = JSON.parse(loginResponse.data.user.U_FMB_ConfigModules);
        localStorage.setItem('userConfigFielsBP', JSON.stringify(U_FMB_ConfigModules.businessPartner));
        localStorage.setItem('userConfigFielsDA', JSON.stringify(U_FMB_ConfigModules.itemData));

        localStorage.setItem(config.localStorageNamed + 'itemsDashboard', JSON.stringify(encryptedMod));
        localStorage.setItem(config.localStorageNamed + 'Token', await DO_THE_RACE(JSON.stringify(loginResponse.data.token), F1_GRILL.CHECO_PEREZ));
        localStorage.setItem(config.localStorageNamed + 'currentUser', JSON.stringify(userResponse));
        await setUser(userResponse);

        if (userResponse.FMB_Role === 'counter1') {
            this.props.history.push('/PointOfSale');
        } else {
            this.props.history.push('/');
        }
    }

    FillCounterPermissions = (dataPermissions) => {
        let permissionsModel = new CounterPermissions();
        if (dataPermissions !== '' && dataPermissions !== undefined && dataPermissions !== null) {
            let counterP = JSON.parse(dataPermissions);
            permissionsModel.EditPrice = counterP.EditPrice || false;
            permissionsModel.EditDiscount = counterP.EditDiscount || false;
        }
        return permissionsModel;
    }

    FillBranchPermissions = (dataPermissions) => {
        let permissionsModel = new BranchPermissions();
        if (dataPermissions !== '' && dataPermissions !== undefined && dataPermissions !== null) {
            const permissions = JSON.parse(dataPermissions);
            permissionsModel.CloseDocuments = permissions.CloseDocuments || false;
            permissionsModel.ProductionPrices = permissions?.ProductionPrices || false;
            permissionsModel.CancelClosePurchaseOrder = permissions.CancelClosePurchaseOrder || false;
            permissionsModel.EditPurchaseOrder = permissions.EditPurchaseOrder || false;
            permissionsModel.ChangeTaxRate = permissions.ChangeTaxRate || false;
            permissionsModel.PendingCashCut = permissions.PendingCashCut || false;
        }
        return permissionsModel;
    }

    CountFMB = () => {
    }

    ShowDynamicModal = (idModal) => {
        $(`#${idModal}`).modal('show');
    }

    HideDynamicModal = (idModal) => {
        $(`#${idModal}`).modal('hide');
    }

    ChangeAuthenticationCode = async (value) => {
        const { notificationReducer: { showAlert } } = this.props;
        if (value.length > 6) {
            showAlert({ type: 'error', message: 'El token de verificación solo debe de ser de 6 caracteres' });
            return;
        }
        this.setState({
            key: value
        })
    }

    CloseActions = async () => {
        await this.setState({
            key: ''
        })
    }

    ValidateAuthenticationCodeTwoSteps = async () => {
        const { key, LoginResponse } = this.state
        const { loginReducer, enableSpinner, notificationReducer: { showAlert } } = this.props;

        if (key.length !== 6) {
            showAlert({ type: 'warning', message: 'El token de verificación debe de ser de 6 caracteres' });
            return;
        }

        const data = {
            email: loginReducer.email,
            action: 2,
            key: key.trim(),
        }

        enableSpinner(true);
        const responseApi = await apiClient.validateTwoSteps(data);
        enableSpinner(false);

        const returnType = typeof responseApi.message;

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: returnType === 'string' ? responseApi.message : 'Token invalido' });
            return;
        }
        showAlert({ type: 'info', message: responseApi.message });
        this.HideDynamicModal('TwoStepsModal-TwoSteps');
        await this.registerSocket(LoginResponse);
        await this.SaveDataForSuccessLogin(LoginResponse)
    }

    ForgetPassword = async () => {
        const { loginReducer, enableSpinner, notificationReducer: { showAlert } } = this.props;

        if (loginReducer.email === '') {
            showAlert({ type: 'info', message: 'Escribe tu email en el campo de correo para saber quien eres y poder mandar al correo al correo registrado.', timeOut: 9000 });
            return;
        }
        const data = {
            email: loginReducer.email
        }
        enableSpinner(true);
        const responseApi = await apiClient.validateChangePassword(data);
        enableSpinner(false);

        if (responseApi.status !== 1) {
            showAlert({ type: 'error', message: responseApi.message });
            return;
        }
        showAlert({ type: 'info', message: responseApi.message });



    }

    changeConfigURL = async (value) => {
        if (value === "local") { localStorage.setItem(config.localStorageNamed + 'ConfigURL', true); }
        else { localStorage.removeItem(config.localStorageNamed + 'ConfigURL'); }
        await this.setState({ configURL: value, database: "CONECTANDO..." });
        await this.getDataBase();
    }

    render() {
        const { key, showWarningModal, database, configURL } = this.state
        const { setEmail, setPassword } = this.props;
        return (
            <div className="d-flex flex-column vh-100" style={{ marginLeft: '4%' }} >
                <div className="container login-container mb-5">
                    <div className="row">
                        <div className="col-md-5 ads text">
                            <div className="d-flex flex-column h-100">
                                {development &&
                                    <div className='p-2 bg-danger rounded-pill text-center h4 text-nowrap'>
                                        AMBIENTE DE PRUEBAS
                                    </div>
                                }
                                <div className='p-2 w-100 text-center' style={{ maxHeight: 375, marginTop: -25 }}>
                                    <img className='imgIntoDiv img-fluid p-4' src={require('../../images/logo_EMPRESA.svg')} alt="Logo Empresa" />
                                </div>
                                <div className='p-2 w-100 text-center h5 text-nowrap'> {database || "SIN CONEXIÓN"} </div>
                                <div className='p-2 mt-auto text-center'>
                                    Otorgado bajo licencia para  {" " + BUSINESSLICENCE}<br /> {new Date().getFullYear()} © FMB Solutions.
                                    Todos los derechos reservados v{currentVersion}
                                </div>
                            </div>
                        </div>

                        <div className="col-md-7 login-form">
                            <div className="profile-img">
                                <img className="img-fluid" src={require("../../images/Timbra-ONE_Login211.png")} alt="Card cap" />
                            </div>
                            <br />
                            <div className="input-group col-xs-12">
                                <span className="form-control" style={{ fontSize: "14px", maxWidth: 35, }}><i className="fas fa-user"></i></span>
                                <input type="email" name="usuario" id="usuario" style={{ textAlign: 'center', fontSize: "14px", }}
                                    placeholder="Ingrese su nombre de usuario" className="form-control" autoFocus
                                    onChange={event => setEmail(event.target.value)} />
                            </div>
                            <br />
                            <div className=" input-group col-xs-12">
                                <span className=" form-control" style={{ fontSize: "14px", maxWidth: 35 }}><i className="fas fa-lock"></i></span>
                                <input type="password" name=" password" id=" password"
                                    style={{ textAlign: 'center', fontSize: "14px", }} placeholder="Ingrese su contraseña"
                                    className="form-control"
                                    onKeyDown={event => event.keyCode === 13 && this.submit()}
                                    onChange={event => setPassword(event.target.value)} />
                            </div>
                            <br />
                            <div className="input-group col-xs-4">
                                <button type="submit"
                                    className="col-md-12 fondo-yellow btn text-white" onClick={this.submit}> Entrar
                                </button>
                            </div>
                            {/* mt-2 mb-2 */}
                            <div className="container">
                                <div className="row justify-content-center ml-3 mt-2">
                                    <button type="button" className="btn text-primary"
                                        onClick={() => { this.ForgetPassword(); }}> ¿Olvidaste tu contraseña?
                                        {/* <i className="fas fa-sign-out-alt"></i> */}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="slcConfigURL mt-auto mr-auto mr-md-2 pb-4 ml-auto" style={{ width: 200 }}>             
                    <i className="fas fa-globe"/>
                    <select className="form-control rounded-pill" value={configURL} onChange={({ target: { value } }) => this.changeConfigURL(value)}>
                        <option value="public"> Conexión publica </option>
                        <option value="local"> Conexión local </option>
                    </select>
                </div>

                <TwoStepsVerificationModal
                    IdModal={'TwoStepsModal-TwoSteps'}
                    TextDestiny={'ingresar al sistema'}
                    ColorHeaderBG={'bg-warning text-dark'}
                    ChangeParam1={this.ChangeAuthenticationCode}
                    ExecuteParam1={this.ValidateAuthenticationCodeTwoSteps}
                    param1={key}
                    CloseActions={this.CloseActions}
                />

                {showWarningModal && 
                    <WarningModal
                        title='Advertencia'
                        message={'¡El tiempo de su sesión ha expirado, debe iniciarla nuevamente!'}
                        size='modal-dialog'
                        btnAccept={'Aceptar'}
                        accept={() => { }}
                        btnCancel={'Cerrar'}
                        cancel={() => { }}
                    />
                }
            </div>
        );
    }
}

const mapStateToProps = store => {
    return {
        loginReducer: store.LoginReducer,
        notificationReducer: store.NotificationReducer,
        configReducer: store.ConfigReducer
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setEmail: value => {
            dispatch({ type: DISPATCH_ID.LOGIN_SET_EMAIL, value });
        },
        setPassword: value => {
            dispatch({ type: DISPATCH_ID.LOGIN_SET_PASSWORD, value });
        },
        setUser: value => {
            dispatch({ type: DISPATCH_ID.LOGIN_SET_USER, value });
        },
        enableSpinner: value => {
            dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value });
        },
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginView);
